// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"807":"b7327ce9","935":"86313f7a"}[chunkId] + ".chunk.js";
};